import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Globals } from '../providers/globals';

import { BaseProvider } from './base-provider';

declare var moment;

@Injectable()
export class ConsumerServiceBookingHandlerProvider extends BaseProvider {
	constructor(
		public http: HttpClient,
		public globals: Globals
	){
		super();

		this.baseUrl = "consumerServiceBooking"
	}

	getBookings(){	
		return new Promise( (resolve, reject) => {

		  	this.url = this.globals.dataUrl + this.baseUrl +
		  			   '?page=' + this.page + '&size=' + this.size;

		    this.http.get(
		        this.url
		    )
		    .subscribe(
		    	(res:any) => {
		    		this.list = res.Data;

		        	resolve(this.list)
		    	}
		    );   
		});    	
  	}	

	bookService(params){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + this.baseUrl + "/agilisa";

			this.http.post(
				this.url,
				params
			)
			.subscribe(
				data => {
					resolve(data);
				},
				err => {reject(err)}
			);
		});       
	}	  	
}